// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  name: 'development',
  firebase: {
    apiKey: "AIzaSyBO71wkgHrsrOfT-MlcBAxczreullgpVoU",
    authDomain: "creditpath-dev.firebaseapp.com",
    projectId: "creditpath-dev",
    storageBucket: "creditpath-dev.firebasestorage.app",
    messagingSenderId: "192143475488",
    appId: "1:192143475488:web:4d2ffdd62abde2274dcd45",
    measurementId: "G-WN3E4W0N0W"
  },
  // App Check enabled in development with debug tokens
  // The debug token is automatically used when running on localhost (see app.config.ts)
  appCheck: {
    recaptchaSiteKey: '6LdiFGEsAAAAACFJX40KdnUnCkdxJv9SFsrvnOCg', // Same key as production
    isTokenAutoRefreshEnabled: true
  },
  api: {
    baseUrl: 'https://us-central1-creditpath-dev.cloudfunctions.net',
  },
  /** When false, hides "Continue with Google" on sign-in/sign-up (users should use work email). Set to true to re-enable. */
  enableGoogleSignIn: false,
};
